export default function TBody({children}) {
  return (
      <tbody className="divide-y divide-gray-200 ">
      {children}
      </tbody>
  )
}